import { useState, useRef } from "react";

import * as Material from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import CustomModal from "../../CustomModal";
import { Button } from "@fragments";

import "./styles.scss";

import {
  FacebookShare,
  LinkedinShare,
  TwitterShare,
  WhatsappShare,
  TelegramShare,
  FacebookMessengerShare,
  EmailShare,
  PinterestShare,
} from "react-share-lite";

export default function ShareContentModal({ }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const REF_details = useRef({});

  const shareUrl = REF_details.current.link || "https://ginastee.com";

  const SharableIn = [
    FacebookShare,
    LinkedinShare,
    TwitterShare,
    WhatsappShare,
    TelegramShare,
    FacebookMessengerShare,
    EmailShare,
    PinterestShare,
  ];

  function onClose() {
    setCopied(false);
    setOpen(false);
    REF_details.current = {};
  }

  function handleCopyUrl() {
    setCopied(true);
    navigator.clipboard.writeText(shareUrl);
    window.setSnackbar("Link copiado com sucesso");
  }

  window.handleOpenShareContentModal = ({ title, link }) => {
    REF_details.current = { title, link };
    setOpen(true);
  };

  return (
    <>
      <CustomModal
        maxWidth={430}
        bottomButtonCancelText="Concluir"
        hideSecondaryButton={false}
        title={"Compartilhar"}
        handleClose={onClose}
        open={open}
        className="share-modal"
        width="100%"
        bodyWrapperStyle={{}}
        bodyComponent={
          <div className="container px-3">
            <h3 className="mb-2 mt-3 ">{REF_details.current.title}</h3>

            <div className="social-share-container mb-2">
              {SharableIn.map((Social, i) => (
                <Social
                  key={i}
                  url={shareUrl}
                  round={true}
                  size={40}
                  blankTarget={true}
                />
              ))}
            </div>

            <Material.Divider className="my-3">Ou copie o link</Material.Divider>

            <div
              className={"copy-link-area pl-2 " + (copied && "copied")}
              onMouseDown={handleCopyUrl}
            >
              <div className="price-checkout-url">{shareUrl}</div>
              <Button
                variant="overlay"
                onClick={handleCopyUrl}
                icon={<>
                  {copied ? (
                    <CheckIcon color="success" />
                  ) : (
                    <ContentCopyIcon fontSize="small" />
                  )}
                </>}
              />
            </div>
          </div>
        }
      />
    </>
  );
}
